export const collator = new Intl.Collator('en', {
	numeric: true,
	sensitivity: 'base',
});

export const groupByAlpha = (AllData, SortBy) => {
	var groupedCollection = {};
	var arr_length = AllData ? AllData.length : 0;
	if (arr_length > 0) {
		AllData.sort((a, b) => {
			if (SortBy === 'Asc') return collator.compare(a.name, b.name);
			else return collator.compare(b.name, a.name);
		});
	}
	for (var i = 0; i < arr_length; i++) {
		var firstLetter = AllData[i].name.charAt(0);
		if (groupedCollection[firstLetter] === undefined) {
			groupedCollection[firstLetter] = [];
		}
		groupedCollection[firstLetter].push({
			id: AllData[i].id,
			name: AllData[i].name,
			urlSlug: AllData[i].urlRedirect != null ? AllData[i].urlRedirect : AllData[i].urlSlug,
			sortOrder: AllData[i].sortOrder,
		});
	}
	return groupedCollection;
};
